const PartnerLogo = ({
	href,
	logoSrc,
	alt,
	needsBackground = false,
}: {
	href: string;
	logoSrc: string;
	alt: string;
	needsBackground?: boolean;
}) => {
	const isSnackThat = alt === "Snack That";

	return (
		<a
			href={href}
			target="_blank"
			rel="noopener noreferrer"
			className={`group flex items-center justify-center border border-white/10 bg-white/5 transition-all duration-300 hover:scale-105 hover:border-ds-yellow/30 hover:bg-white/10 hover:shadow-lg ${
				isSnackThat
					? "max-w-32 mx-auto aspect-square max-h-32 rounded-full"
					: "rounded-lg p-6"
			}`}
		>
			<img
				src={logoSrc}
				alt={alt}
				className={`transition-all duration-300 group-hover:brightness-110 ${
					isSnackThat
						? "h-full w-full rounded-full object-cover"
						: "max-h-16 w-full object-contain sm:max-h-20"
				} ${needsBackground ? "brightness-0 invert filter" : ""}`}
			/>
		</a>
	);
};

const EngagementPartner = () => {
	return (
		<div className="bg-ds-gray-normal py-16 px-6 text-white sm:py-20 sm:px-12 xl:px-28 2xl:px-44">
			<div className="mx-auto flex max-w-6xl flex-col items-center text-center">
				<h1 className="mb-12 text-4xl text-ds-yellow md:text-5xl">
					Engagement & Partner
				</h1>

				<div className="mb-12 grid w-full max-w-4xl grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
					<PartnerLogo
						href="https://www.ratmoko.ch/"
						logoSrc="/assets/partners/moira.png"
						alt="Moira Joy"
					/>
					<PartnerLogo
						href="https://www.snack-that.ch/"
						logoSrc="/assets/partners/snack.png"
						alt="Snack That"
					/>
					<PartnerLogo
						href="https://www.metromodels.com/de/"
						logoSrc="/assets/partners/metro.png"
						alt="Metro Models"
						needsBackground={true}
					/>
				</div>

				<div className="max-w-3xl">
					<p className="text-lg leading-relaxed sm:text-xl">
						"Wir engagieren uns für eine{" "}
						<span className="text-ds-yellow">
							nachhaltige Zukunft
						</span>{" "}
						sowie für{" "}
						<span className="text-ds-yellow">Kunst & Kultur</span>.
						<br />
						Dabei unterstützen wir Start-up´s, Künstler und arbeiten
						Hand in Hand mit professionellen Partnern."
					</p>
				</div>
			</div>
		</div>
	);
};

export default EngagementPartner;
